import { Client } from 'adapters';
import { Client as IClient, HeaderData } from 'adapters/types';

export const mockHeaders: HeaderData = {
  'x-department-name': 'TOY-A',
  'x-enterprise-id': 'E336542',
  'x-store-id': 'S100106190',
  'remote-user': 'admin1099@drivemod.com',
  authorization: 'Bearer c80718a8-313c-4535-9604-7eaf995d0da4'
};

export const mockClient: IClient = {
  ...Client,
  headers: mockHeaders
};
